const messages = {
    en: {
      message: {
        hello: 'hello world',
        button_contact: 'Apply',
        button_home: 'Video',
        contact_text: ['Become an argonaut of infinite visual space with Saatchi & Saatchi IS Design Department:', 
        'Find this treasure with us. Join Saatchi & Saatchi Creative Department'],
        contact_text_portfolio: 'Send your portfolio at:'
      },
      video: [
          { src: '../../assets/video/Saatchi-SaatchIS.mp4', format: 'mp4' }
      ]
  },
  pl: {
    message: {
      hello: 'dzień dobry',
      button_contact: 'Aplikuj',
      button_home: 'Filmy',
      contact_text: ['Zostań argonautą nieskończonej wizualnej przestrzeni z Saatchi & Saatchi IS Design Department:', 
                      'Znaleźć ten skarb z nami. Dołącz do Saatchi & Saatchi Creative Department'],
      contact_text_portfolio: 'Wyślij swoje CV na:'
    },
    video: [
        { src: '../../assets/video/Saatchi-SaatchIS.mp4', format: 'mp4' }
    ]
      
  }

}

export default messages


// WEBPACK FOOTER //
// ./src/localizations/messages.js